import { graphql } from "@/gql";

export const updateDefaultRateMutation = graphql(`
  mutation UpdateDefaultRate($id: ID!, $input: UpdateDefaultRateInput!) {
    updateDefaultRate(id: $id, input: $input) {
      id
    }
  }
`);
